import type { Invoice } from '@bcl/shared';
import { api } from '@/lib/api';

export type MineInvoice = Invoice & {
  projectReference: string;
  paymentMethod: string;
};

export async function listMineInvoices(): Promise<MineInvoice[]> {
  const { data } = await api.get<MineInvoice[]>('/invoices/mine');
  return data;
}

export async function getInvoiceByPayment(
  paymentId: string,
): Promise<Invoice | null> {
  try {
    const { data } = await api.get<Invoice>(
      `/invoices/by-payment/${paymentId}`,
    );
    return data;
  } catch (err: unknown) {
    const status = (err as { response?: { status?: number } })?.response
      ?.status;
    if (status === 404) return null;
    throw err;
  }
}

export async function getInvoiceDownloadUrl(
  invoiceId: string,
): Promise<string> {
  const { data } = await api.get<{ url: string }>(
    `/invoices/${invoiceId}/download-url`,
  );
  return data.url;
}
